'use client'
import React from 'react'

import BottomSheet from '@/shared/components/BottomSheet'
import { Caption, Text, Tint } from '@/shared/components/typography'

type PurchaseNoticeProps = {
  isOpen: boolean
  onClose: () => void
}

const PurchaseNotice = ({ isOpen, onClose }: PurchaseNoticeProps) => {
  const bodyContent = (
    <div className="flex w-full flex-col px-2">
      <div className="mb-8 mt-6">
        <Text level="text3" color="text090">
          입차 예정 시간보다 빨리 또는 늦게 입차해도 <br />
          <strong>유효시간 내에만 입차</strong>하면 이용이 가능합니다.
        </Text>
      </div>
      <div className="relative mb-4 flex h-[24px] w-full rounded bg-main-010">
        <div className="absolute left-[14px]">
          <Tint level="tint1" color="main090">
            주차권 유효시간
          </Tint>
        </div>
        <div className="absolute left-1/2 min-w-[96px] rounded-[4px] bg-main-070 px-3 text-center">
          <Tint level="tint1" color="text010">
            입차 예정 시간
          </Tint>
        </div>
      </div>
      <div className="mb-10">
        <Caption level="caption2" color="text070">
          ※ 유효시간을 벗어날 경우 사용이 불가합니다.
        </Caption>
      </div>
    </div>
  )
  return (
    <BottomSheet
      isOpen={isOpen}
      className="body-1 h-[56px]"
      pyValue="py-0"
      title="입차 예정 시간 안내"
      bodyContent={bodyContent}
      btnText="닫기"
      onClick={onClose}
    />
  )
}

export default PurchaseNotice
